import React from 'react';
import { ExternalLink, User, Bot, FileText, Link, Users } from 'lucide-react';
type MessageResource = {
  type: 'link' | 'document' | 'connection';
  title: string;
  url?: string;
};
type MessageProps = {
  message: {
    id: string;
    content: string;
    sender: 'user' | 'agent';
    timestamp: Date;
    resources?: MessageResource[];
  };
};
const AgentMessage = ({
  message
}: MessageProps) => {
  const isAgent = message.sender === 'agent';
  return <div className={`flex ${isAgent ? 'justify-start' : 'justify-end'}`} data-id="element-49">
      <div className={`max-w-[80%] ${isAgent ? 'bg-white border' : 'bg-blue-600 text-white'} rounded-lg px-4 py-3 shadow-sm`} data-id="element-50">
        <div className="flex items-center mb-2" data-id="element-51">
          <div className={`rounded-full p-1 mr-2 ${isAgent ? 'bg-blue-100' : 'bg-blue-500'}`} data-id="element-52">
            {isAgent ? <Bot className="w-4 h-4 text-blue-600" data-id="element-53" /> : <User className="w-4 h-4 text-white" data-id="element-54" />}
          </div>
          <span className="text-sm font-medium" data-id="element-55">
            {isAgent ? 'Growth Agent' : 'You'}
          </span>
          <span className="text-xs opacity-70 ml-2" data-id="element-56">
            {message.timestamp.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
          })}
          </span>
        </div>
        <p className="text-sm whitespace-pre-wrap" data-id="element-57">{message.content}</p>
        {isAgent && message.resources && message.resources.length > 0 && <div className="mt-3 space-y-2" data-id="element-58">
            <p className="text-xs font-medium text-gray-500" data-id="element-59">Resources:</p>
            {message.resources.map((resource, index) => <div key={index} className="flex items-center bg-gray-50 p-2 rounded text-sm" data-id="element-60">
                {resource.type === 'link' && <Link className="w-4 h-4 mr-2 text-blue-500" data-id="element-61" />}
                {resource.type === 'document' && <FileText className="w-4 h-4 mr-2 text-orange-500" data-id="element-62" />}
                {resource.type === 'connection' && <Users className="w-4 h-4 mr-2 text-green-500" data-id="element-63" />}
                <span className="flex-1 text-gray-800" data-id="element-64">{resource.title}</span>
                {resource.url && <a href={resource.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800" data-id="element-65">
                    <ExternalLink className="w-4 h-4" data-id="element-66" />
                  </a>}
              </div>)}
          </div>}
      </div>
    </div>;
};
export default AgentMessage;